import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightCircle, PlayIcon } from "lucide-react";
import { motion } from "framer-motion";
import ImageSlider from '../components/imageSlider';

const images = Array.from({ length: 10 }, (_, i) =>
  `/images/products/${i + 1}.png`
);

export default function Home() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    videoRef.current.play();
    setIsPlaying(true);
  };

  const handlePause = () => {
    videoRef.current.pause();
    setIsPlaying(false);
  };

  const [data, setData] = useState([]);
  const [pending, setPending] = useState(true);
  const [whyUsReason, setWhyUsReason] = useState(true);
  const [provider, setProvider] = useState([]);
  const [product, setProduct] = useState([]);
  const [statistic, setStatistic] = useState([]);
  const [testimoni, setTestimoni] = useState([]);
  const [running, setRunning] = useState(true);

  const fetchBanner = async () => {
  
    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/hero/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setBanner(json.data || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };
  
  useEffect(() => {
    fetchBanner();
  }, []);  

  const fetchWhy = async () => {
  
    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/whyus/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setWhy(json.data || []);

    } catch (err) {
        console.error("Fetch Why error:", err);
    }
  };
  
  useEffect(() => {
    fetchWhy();
  }, []);  

  const fetchRunning = async () => {
  
    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/running/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setRunning(json.data || []);

    } catch (err) {
        console.error("Fetch Running error:", err);
    }
  };
  useEffect(() => {
    fetchRunning();
  }, []);  


  const imagesFeature = [
    "1.png",
    "2.png",
    "3.png",
  ];

  const [banner, setBanner] = useState({
    title: "",
    subtitle: "",
    description: "",
    video: "", 
  });

  const [why, setWhy] = useState({
    title: "",
    description: "",
    gif: "", 
  });

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(false);  
  const [isSpinning, setIsSpinning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsSpinning(true);

      // ganti gambar saat posisi 180deg
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % images.length);
      }, 500);

      // stop animasi setelah 1 detik
      setTimeout(() => {
        setIsSpinning(false);
      }, 1000);

    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const [active, setActive] = useState(0);

  const fetchWhyUsReason = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/whyusreason`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setWhyUsReason(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
    
  useEffect(() => {
    fetchWhyUsReason();
  }, []);

  const safeFeatures = Array.isArray(whyUsReason) ? whyUsReason : [];
  const half = Math.ceil(safeFeatures.length / 2);

  const leftFeatures = safeFeatures.slice(0, half);
  const rightFeatures = safeFeatures.slice(half);

  const fetchProvider = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/provider`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setProvider(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
    
  useEffect(() => {
    fetchProvider();
  }, []);

  const fetchTestimoni = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/testimoni`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setTestimoni(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
    
  useEffect(() => {
    fetchTestimoni();
  }, []); 

  const fetchProduct = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/products`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setProduct(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
    
  useEffect(() => {
    fetchProduct();
  }, []); 

  const fetchStatistic = async () => {
  
    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/statistic/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setStatistic(json.data || []);

    } catch (err) {
        console.error("Fetch Statistic error:", err);
    }
  };
  
  useEffect(() => {
    fetchStatistic();
  }, []);  

  const text=banner.title;
  
  const [displayText, setDisplayText] = useState("");
  const [index2, setIndex2] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (!text) return;

    const speed = isDeleting ? 40 : 80;

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        // ngetik
        setDisplayText(text.substring(0, index2 + 1));
        setIndex2((prev) => prev + 1);

        // kalau sudah full → pause → mulai hapus
        if (index2 + 1 === text.length) {
          setTimeout(() => setIsDeleting(true), 1200);
        }
      } else {
        // hapus
        setDisplayText(text.substring(0, index2 - 1));
        setIndex2((prev) => prev - 1);

        // kalau sudah habis → mulai lagi
        if (index2 <= 0) {
          setIsDeleting(false);
        }
      }
    }, speed);

    return () => clearTimeout(timeout);
  }, [index2, isDeleting, text]);

  return (
    <div className="min-h-screen bg-slate-100/95 text-gray-700">
      {/* Hero Section */}
      <section 
        data-section="hero"
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
      >
        <div className="absolute inset-0 pointer-events-none"></div>

        {/* Animated Glow Background */}
        <div className="absolute inset-0 pointer-events-none">
          <video
            className="absolute inset-0 w-full h-full object-cover pointer-events-none"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src="/images/kenzie.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40"></div>
        </div>
        <div className={`relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${
          visibleSections.has('hero') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mb-12 z-10">
            <div className='flex flex-col max-w-3xl'>
              <h1 className="font-bricolage  text-4xl md:text-6xl mt-[128px] lg:mt-0 mb-6 bg-red-500 p-1 text-white ">
                {displayText}
              </h1>
              <p className="text-xl md:text-xl text-white mb-8 max-w-3xl mx-auto">
                {banner.description}
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/services"
                  className="px-8 flex gap-4 flex-row py-4 bg-gradient-to-r from-red-600  to-[#3E3274] text-white rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300"
                >
                  Gabung Yuk! <ArrowRightCircle size={28}></ArrowRightCircle>
                </Link>
              </div>
            </div>
            {/* <div className='flex items-center'>
              <div className="relative w-[700px] rounded-3xl overflow-hidden">
                <img
                  src="/images/banner_01.png"
                  alt="Team Working"
                  className="h-full object-cover"
                />
                <div className="absolute inset-0 bg-transparent" />
                <div className="absolute -top-3 -left-3 md:-top-5 md:-left-5 w-24 h-24 md:w-40 md:h-40 flex items-center justify-center">
                  <div className="absolute w-full h-full animate-spin-slow">
                    <svg viewBox="0 0 200 200" className="w-full h-full">
                      <defs>
                        <path
                          id="circlePath"
                          d="M 100, 100
                            m -60, 0
                            a 60,60 0 1,0 120,0
                            a 60,60 0 1,0 -120,0"
                        />
                      </defs>

                      <text
                        fill="red"
                        fontSize="10"
                        className="md:text-[12px]"
                        fontWeight="600"
                        letterSpacing="2"
                      >
                        <textPath href="#circlePath">
                          - The Best Choice for Online & Payment Products
                        </textPath>
                      </text>
                    </svg>
                  </div>
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center animate-pulse-slow">
                    <img src="/images/sticker-rp.png" className="w-full h-full object-contain" />
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>

          
      </section>

      {/* Features Overview Section */}
      <section 
        data-section="features"
        className="py-36 bg-gradient-to-b from-slate-100/95 to-slate-200/95 relative overflow-hidden"
      >
        <div className="absolute top-0 w-full bg-red-500 backdrop-blur-lg overflow-hidden p-4">
          {/* Marquee */}
          <div className="overflow-hidden w-full">
            <div className="flex whitespace-nowrap animate-marquee2">
              
              {/* ORIGINAL */}
              <div className="flex items-center gap-16">
                <span className="text-md text-white font-bold">
                  {running.running_text}
                </span>
              </div>

              {/* DUPLICATE */}
              <div className="flex items-center gap-16 ml-16">
                <span className="text-md text-white font-bold">
                  {running.running_text}
                </span>
              </div>

            </div>
          </div>
        </div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blue-600 via-transparent to-transparent"></div>
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('features') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
              <span className='font-bricolage mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent animate-gradient bg-[length:200%_auto]'>{why.title}</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-[#3E3274] mx-auto mb-4"></div>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              {why.description}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/** LEFT COLUMN */}
            <div className="flex flex-col gap-6">
              {leftFeatures.map((feature, index) => (
                <div
                  key={feature.id}
                  className="group p-6 bg-white backdrop-blur-sm rounded-2xl hover:bg-white transition-all duration-300 transform hover:scale-105"
                >
                  <div className="text-4xl mb-4 transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-300">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}uploads/images/${feature.image}`}
                      alt=""
                      className="h-20 transition duration-500 rounded-3xl"
                    />
                  </div>
                  <h3 className="font-bricolage text-lg font-bold mb-2 text-slate-700">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 text-sm">{feature.description}</p>
                </div>
              ))}
            </div>

            {/** CENTER COLUMN */}
            <div className="flex justify-center items-center">
              <ImageSlider images={imagesFeature}></ImageSlider>
              {/* <img
                src="/images/why.gif"
                alt="Animation"
                className="w-full max-w-xl object-contain"
              /> */}
            </div>

            {/** RIGHT COLUMN */}
            <div className="flex flex-col gap-6">
              {rightFeatures.map((feature, index) => (
                <div
                  key={feature.id}
                  className="group p-6 bg-white backdrop-blur-sm rounded-2xl hover:bg-white  transition-all duration-300 transform hover:scale-105"
                >
                  <div className="text-4xl mb-4 transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-300">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}uploads/images/${feature.image}`}
                      alt=""
                      className="h-20 transition duration-500 rounded-3xl"
                    />
                  </div>
                  <h3 className="font-bricolage text-lg font-bold mb-2 text-slate-700">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 text-sm">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* Quick Stats Section */}
      <section 
        className="bg-white">
        <div className="py-8 flex justify-center">
          <div className="relative max-w-7xl rounded-2xl overflow-hidden shadow-2xl px-4">
            {/* VIDEO */}
            <video
              ref={videoRef}
              className="w-full object-contain"
              onClick={isPlaying ? handlePause : handlePlay}
            >
              <source
                src={`${process.env.REACT_APP_BASE_URL}uploads/video/coorporate.mp4`}
                type="video/mp4"
              />
            </video>

            {/* OVERLAY PLAY BUTTON */}
            {!isPlaying && (
              <div
                onClick={handlePlay}
                className="absolute inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm cursor-pointer transition"
              >
                <div className="relative w-40 h-40 flex items-center justify-center">

                  {/* ROTATING TEXT */}
                  <div className="absolute w-full h-full animate-spin-slow">
                    <svg viewBox="0 0 200 200" className="w-full h-full">
                      <defs>
                        <path
                          id="circlePath"
                          d="M 100, 100
                            m -75, 0
                            a 75,75 0 1,1 150,0
                            a 75,75 0 1,1 -150,0"
                        />
                      </defs>

                      <text
                        fill="white"
                        fontSize="16"
                        fontWeight="600"
                        letterSpacing="3"
                      >
                        <textPath href="#circlePath">
                          • CLICK TO PLAY - CLICK TO PLAY •
                        </textPath>
                      </text>
                    </svg>
                  </div>

                  {/* CENTER ICON */}
                  <div className="w-14 h-14 bg-indigo-600 rounded-full flex items-center justify-center animate-pulse-slow shadow-xl text-white text-2xl">
                    <PlayIcon size={24}></PlayIcon>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        
      </section>

      {/* Quick Stats Section */}
      <section 
        className="bg-white">
        <div className="py-16 flex justify-center">
          
          {/* Outer Box */}
          <div className="relative w-full border border-slate-600 bg-slate-400/20 backdrop-blur-lg overflow-hidden p-8">

            {/* Title */}
            <div className="text-center mb-8">
              <span className="px-4 py-2 text-sm rounded-full border border-blue-400/30 bg-blue-400/10 text-[#3E3274]">
                ● Kami menyediakan berbagai produk ●
              </span>
            </div>

            {/* Marquee */}
            <div className="relative overflow-hidden">
              <div className="flex gap-16 w-max animate-marquee">

                {[...provider, ...provider].map((item, index) => (
                  <img
                    key={index}
                    src={`${process.env.REACT_APP_BASE_URL}/uploads/images/${item.image}`}
                    className="h-12 w-auto object-contain opacity-70 hover:opacity-100 transition duration-300"
                  />
                ))}

              </div>
            </div>
          </div>
        </div>
      </section>

      <section data-section="stats"
        className="bg-gradient-to-b from-red-500 to-[#3E3274] overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>
        <div className="h-[400px] lg:h-[800px] w-full flex overflow-hidden">
          {product.map((item, index) => {
            const isActive = active === index;
            return (
              <div
                key={index}
                onMouseEnter={() => setActive(index)}
                className={`
                  relative h-full flex items-center justify-center
                  cursor-pointer
                  transition-all duration-1000 ease-[cubic-bezier(0.4,0,0.2,1)]
                  ${isActive ? "lg:basis-[45%] basis-[45%]" : "basis-[10%] lg:basis-[15%]"}
                `}
              >
                {/* Background */}
                <div
                  className={`
                    absolute inset-0 transition-all duration-1000
                    ${
                      isActive
                        ? "bg-gradient-to-r from-red-500 to-[#3E3274]"
                        : "bg-slate-200/40"
                    }
                  `}
                />

                {/* Content */}
                <div className="relative z-10 text-center text-white px-6">
                  {isActive ? (
                    <h1 className="font-bricolage text-xl lg:text-4xl font-semibold tracking-wide">
                      {item.title} 
                    </h1>
                  ) : (
                    <div className="flex items-center justify-center h-full">
                      <h1
                        className="font-bricolage 
                          text-4xl font-semibold tracking-widest
                          [writing-mode:vertical-rl]
                          rotate-180
                        "
                      >
                        {item.title}
                      </h1>
                      
                    </div>
                  )}

                  <div
                    className={`
                      transition-all duration-1500 overflow-hidden p-4
                      ${isActive ? "opacity-100 mt-3" : "opacity-0 h-0"}
                    `}
                  >
                    <p className="text-gray-300 text-xs lg:text-lg mb-8">
                      {item.description}
                    </p>
                    <div className="relative group">
                      <div className='group-hover:scale-75 transition duration-700'>
                        <img
                          src={`${process.env.REACT_APP_BASE_URL}uploads/images/${item.image}`}
                          alt=""
                          className={`h-100 w-full transition duration-500 rounded-3xl`}/>
                        <div className="absolute inset-0 rounded-xl shadow-[0_0_70px_rgba(0,255,255,0.6)] opacity-0 group-hover:opacity-100 transition duration-500"></div>
                      </div> 

                    </div>
                  </div>
                </div>

                {/* Futuristic Glow */}
                {isActive && (
                  <div className="absolute inset-0 border border-cyan-400/40 animate-pulse pointer-events-none" />
                )}
              </div>
            );
          })}
        </div>
      </section>
      
      <section 
        data-section="stats"
        className="py-24 bg-white"
      >
        <div className={`relative w-full  mx-auto px-4 sm:px-6 lg:px-8 transition-all ${
          visibleSections.has('stats') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { number: statistic.mitra, label: 'Mitra', color: 'blue' },
              { number: statistic.produk, label: 'Produk', color: 'red' },
              { number: statistic.transaksi_harian, label: 'Transaksi Harian', color: 'blue' },
              { number: statistic.mitra_perhari, label: 'Mitra Perhari', color: 'red' },
            ].map((stat, index) => (
              <div
                key={index}
                className="text-center p-8 bg-white backdrop-blur-sm rounded-3xl border border-[#3E3274] hover:border-blue-500/50 transition-all transform hover:scale-110"
                style={{ transitionDelay: `${index * 1000}ms` }}
              >
                <div className={`text-4xl md:text-5xl font-bold mb-2 bg-gradient-to-r ${
                  stat.color === 'blue' ? 'from-blue-400 to-[#3E3274]' : 'from-red-500 to-pink-400'
                } bg-clip-text text-transparent`}>
                  {stat.number}+
                </div>
                <div className="text-gray-700 text-lg">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section 
        data-section="testimonials"
        className="py-24 bg-gradient-to-b from-slate-100/95 to-slate-200/95 "
      >
        <div className={`w-full mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-500 ${
          visibleSections.has('testimonials') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="text-center mb-16">
            <h2 className="font-bricolage text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-red-500 to-[#3E3274]  bg-clip-text text-transparent">
              Apa kata mereka tentang Kenzie Komunika?
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-[#3E3274] mx-auto"></div>
          </div>

          <div className="w-full overflow-hidden py-10 bg-gradient-to-b from-slate-100/95 to-slate-200/95 ">
            <motion.div
              className="flex gap-8 cursor-grab active:cursor-grabbing"
              drag="x"
              dragConstraints={{ left: -1500, right: 0 }}
              animate={{ x: ["0%", "-50%"] }}
              transition={{
                repeat: Infinity,
                duration: 20,
                ease: "linear"
              }}
            >
              {[...testimoni, ...testimoni].map((testimonial, index) => (
                <div
                  key={index}
                  className="min-w-[350px] p-8 bg-white backdrop-blur-sm rounded-2xl border border-[#3E3274] hover:border-blue-500/50 transition-all duration-300"
                >
                  <div className="text-to-[#3E3274] text-4xl">"</div>
                  <p className="text-gray-700 mb-6 italic">
                    {testimonial.komentar}
                  </p>
                  <div className="flex items-center space-x-4">
                    {testimonial.image ? (
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}uploads/images/${testimonial.image}`}
                        alt={testimonial.nama}
                        className="w-12 h-12 rounded-full object-cover"
                      />
                    ) : (
                      <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-[#3E3274] rounded-full flex items-center justify-center">
                        <span className="text-white font-bold">
                          {testimonial.nama?.[0]}
                        </span>
                      </div>
                    )}
                    <div>
                      <h4 className="text-slate-700 font-semibold">
                        {testimonial.nama}
                      </h4>
                      <p className="text-gray-600 text-sm">
                        {testimonial.sumber}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section 
        data-section="cta"
        className="py-24 bg-white relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-red-500/20 rounded-full blur-3xl"></div>
        </div>

        <div className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 ${
          visibleSections.has('cta') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-bricolage text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent">
            Ayo bergabung menjadi mitra Kami!
          </h2>
          <p className="text-xl text-slate-700 mb-8">
            Kami tidak hanya menyediakan layanan, tetapi membangun kemitraan jangka panjang untuk perkembangan bisnis Anda.
          </p>
          <Link 
            to="/contact"
            className="inline-block px-10 py-4 bg-gradient-to-r from-red-500 to-[#3E3274] rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300 text-white"
          >
            Mulai mendaftar
          </Link>
        </div>
      </section>

      <style jsx>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-gradient {
          animation: gradient 3s ease infinite;
        }
      `}</style>
    </div>
  );
}
